export default [
  {
    path: 'scene-list',
    name: 'scene-list',
    component: () => import('./scene-list.vue'),
    meta: {
    }
  }, {
    path: 'book-list',
    name: 'book-list',
    component: () => import('./book-list.vue'),
    meta: {
    }
  }
];


// WEBPACK FOOTER //
// ./src/views/operate/books/index.route.js